export default {
  functional: true,
  render(h, { props, section, children }) {
    const tagName = section ? 'section' : 'div'

    const classNames = {
      container: true,
      'is-mobile-fluid': props.mobileFluid,
    }

    return h(tagName, { class: classNames }, children)
  }
}
